import React from "react";
import { LayoutRendererProvider } from "../LayoutRendererProvider/LayoutRendererProvider";

export const LayoutRenderer = (props) => {
	return <LayoutRendererProvider {...props} />;
};
